import { KEYCLOAK_HOST } from './environment'
import Keycloak from 'keycloak-js'

// @ts-expect-error lacks constructor signature
export const keycloak = new Keycloak({
  url: KEYCLOAK_HOST,
  realm: 'TomraConnectUsers',
  clientId: 'assortment-management-ui',
})

export type ScopedAccess = {
  app: string
  role: string
  scopeId: string
  permissions: string[]
}

/**
 * Parses a single `scoped_resource_access` entry of the form:
 *   `<App>#<Role>#<ScopeId>#<perm1>;<perm2>;...`
 *
 * Returns `null` for malformed entries (wrong segment count, empty segment,
 * empty permission list, or non-string input).
 */
export const parseScopedAccess = (entry: unknown): ScopedAccess | null => {
  if (typeof entry !== 'string') return null
  const parts = entry.split('#')
  if (parts.length !== 4) return null
  const [app, role, scopeId, perms] = parts
  if (!app || !role || !scopeId || !perms) return null
  const permissions = perms
    .split(';')
    .map((p) => p.trim())
    .filter(Boolean)
  if (permissions.length === 0) return null
  return { app, role, scopeId, permissions }
}

const getScopedAccessEntries = (): ScopedAccess[] => {
  const raw = keycloak.tokenParsed?.scoped_resource_access
  if (!Array.isArray(raw)) return []
  return raw.map(parseScopedAccess).filter((e): e is ScopedAccess => e !== null)
}

export const loggedInUserHasPermission = (permission: string) =>
  getScopedAccessEntries().some((e) => e.permissions.includes(permission))

export const loggedInUserHasRoleWithPermission = (role: string, permission: string) =>
  getScopedAccessEntries().some((e) => e.role === role && e.permissions.includes(permission))
